import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment-timezone';
import { getUserLanguage } from '../../../../utils/LanguageUtil';

const SuperMatchAssessmentDetails = ({ assessment, respondent }) => {
  const { formatDate } = useIntl();

  const { translatedTags } = useSelector((state) => state.i18n);

  const language = getUserLanguage(assessment.locale, translatedTags);

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <h2 className="text-muted">
          <FormattedMessage id="assessment" defaultMessage="Assessment">
            {(text) => (
              <span>
                {`${text}: `}
                <strong>{assessment.template.title}</strong>
              </span>
            )}
          </FormattedMessage>
        </h2>
      </div>
      <div className="p-col-12">
        <div className="details">
          <FormattedMessage id="attrs.language" defaultMessage="Language">
            {(text) => (
              <>
                <span>{`${text}: `}</span>
                <span>{language.label}</span>
              </>
            )}
          </FormattedMessage>
        </div>
        <div className="details">
          <FormattedMessage id="attrs.created" defaultMessage="Created">
            {(text) => (
              <>
                <span>{`${text}: `}</span>
                <span>
                  {formatDate(moment(assessment.createdOn), {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                  })}
                </span>
              </>
            )}
          </FormattedMessage>
        </div>
        <div className="details">
          <FormattedMessage id="attrs.email" defaultMessage="Email">
            {(text) => (
              <>
                <span>{`${text}: `}</span>
                <span>{respondent.email}</span>
              </>
            )}
          </FormattedMessage>
        </div>
      </div>
    </div>
  );
};

export default SuperMatchAssessmentDetails;
